import React, { Component, useState } from 'react';
import { Row, Col } from 'reactstrap';
import styles from '../../screens/Vendor/Apple/ClaimOverview.module.css';
import classNames from 'classnames';
import NumberFormat from 'react-number-format';
import DetailsDisplayBlock from '../../components/shared/DetailsDisplay/DetailsDisplayBlock';
import moment from 'moment';
import useTranslation from '../../components/contexts/LanguageTranslation/useTranslation';
import PageLoading from '../../components/shared/PageLoading/PageLoading';
import { UseTranslationInClassComponent } from '../../components/contexts/LanguageTranslation/UseTranslationInClassComponent';
import InternationalPhoneWithCode from '../../components/shared/PhoneNumberUtility/InternationalPhoneWithCode';
import VisaIcon from '../../assets/images/cc-visa.svg';
import { ReactComponent as PaperIcon } from '../../assets/images/paper.svg';
import MasterCardIcon from '../../assets/images/cc-mastercard.svg';
import AmexIcon from '../../assets/images/cc-amex.svg';
import DiscoverIcon from '../../assets/images/cc-discover.svg';
import PhoneImage from '../../assets/images/Vendor/Apple/ApplePhone.png';
import WatchImage from '../../assets/images/Vendor/Apple/watch.png';
import TabletImage from '../../assets/images/Vendor/Apple/tablet.png';
import { ViewFileModal } from '../../components/modals/ViewFileModal';

const currencyPrefixCountries = ['IE', 'NZ', 'US', 'AUS', 'CL', 'MX', 'IN', 'JP'];

let btmLine = styles.btmLine;
let caseTitle = styles.caseTitle;
let colLg5 = 'col-lg-5';
let noGutters = 'no-gutters';
let h6 = 'h6';

export default function ClaimDetails({
    ccType,
    ccNumber,
    claimOverview,
    pendingIncidentStatus = false,
    errorMessage,
    caseNumber,
    address,
    clientId,
    countryCode
}) {
    const [viewFileModal, setViewFileModal] = useState(false);
    const [selectedDoc, setSelectedDoc] = useState(null);
    const international = useTranslation('screens/ProgressScreenDetails/ClaimDetails');
    const {
        country,
        language,
        countryVars: { currency, date },
        englishVars,
        translations
    } = international;

    const getCCType = () => {
        switch (ccType) {
            case 'visa':
                return (
                    <img
                        className={styles.ccImage}
                        alt='Visa'
                        src={VisaIcon}
                    />
                );
            case 'mastercard':
                return (
                    <img
                        className={styles.ccImage}
                        alt='mastercard'
                        src={MasterCardIcon}
                    />
                );
            case 'amex':
                return (
                    <img
                        className={styles.ccImage}
                        alt='Amex'
                        src={AmexIcon}
                    />
                );
            case 'discover':
                return (
                    <img
                        className={styles.ccImage}
                        alt='Discover'
                        src={DiscoverIcon}
                    />
                );
            default:
                return (
                    <img
                        className={styles.ccImage}
                        alt='Unidentified'
                    />
                );
        }
    };

    const getDeviceImage = () => {
        if (claimOverview?.modelNumber?.toLowerCase()?.includes('watch')) {
            return WatchImage;
        } else if (claimOverview?.modelNumber?.toLowerCase()?.includes('ipad')) {
            return TabletImage;
        } else {
            return PhoneImage;
        }
    };

    const getUploadedDocs = (doc) => {
        return (
            <li className={styles.supportingDocsStyle}>
                <a onClick={() => handleViewFileModal(doc)}>
                    <PaperIcon className={styles.paperIcon} />
                    {doc?.documentName}
                </a>
            </li>
        );
    };

    const handleViewFileModal = (doc) => {
        setSelectedDoc(doc);
        setViewFileModal(true);
    };

    const currencySuffix = () => {
        switch (country) {
            case 'AT':
            case 'DK':
            case 'FI':
            case 'NL':
            case 'NO':
            case 'SE':
            case 'CH':
            case 'DE':
            case 'UK':
            case 'IT':
            case 'ES':
            case 'FR':
            case 'VN':
                return ` ${currency.symbol}`;
            default:
                return '';
        }
    };

    const getIncidentType = (type, translations) => {
        if (type === 'theft') {
            return translations?.theftOn || 'Theft on ';
        } else {
            return translations?.lossOn || 'Loss on ';
        }
    };

    return (
        <section
            id='claimDetails'
            className={styles.overviewSection}
        >
            <Row className={classNames(noGutters, btmLine)}>
                <h2 className='h2 col-lg-7 mb-0'>{translations.title || 'Details of Your Claim'}</h2>
                <h2 className={classNames(colLg5, caseTitle, h6)}>
                    {translations.caseNumber || 'Case ID:'} {!claimOverview || !caseNumber ? '' : caseNumber}{' '}
                </h2>
            </Row>

            {!claimOverview && !errorMessage && (
                <Row>
                    <Col className='d-flex flex-column align-items-center justify-content-center'>
                        <PageLoading
                            text={translations.loading || 'Loading Claim Details'}
                            height={100}
                        />
                    </Col>
                </Row>
            )}

            {errorMessage && !claimOverview && <p>{errorMessage}</p>}

            {claimOverview && (
                <Row className={styles.claimInfoRow}>
                    <Col
                        md='7'
                        className={styles.claimInfo}
                    >
                        <h3 className={styles.claimDetailsH6}>{translations.claimedDevice || 'Claimed Device'}</h3>
                        <Row className={styles.deviceInfo}>
                            <img
                                className={styles.deviceImg}
                                src={getDeviceImage()}
                                role='presentation'
                            />
                            <Col lg='12'>
                                {claimOverview?.modelNumber && (
                                    <div className='no-gutters'>
                                        <b className={`col-2 ${country === 'DE' ? 'col-lg-6' : 'col-lg-3'}`}>
                                            {translations.model || 'Model'}:{' '}
                                        </b>
                                        <span className={`col-10 ${country === 'DE' ? 'col-lg-6' : 'col-lg-9'}`}>
                                            {claimOverview?.modelNumber ? claimOverview?.modelNumber : ''}
                                        </span>
                                    </div>
                                )}
                                {claimOverview?.serialNumber && (
                                    <div className='no-gutters'>
                                        <b className={`col-2 ${country === 'DE' ? 'col-lg-6' : 'col-lg-3'}`}>
                                            {translations.serial || 'Serial'}:{' '}
                                        </b>
                                        <span className={`col-10 ${country === 'DE' ? 'col-lg-6' : 'col-lg-9'}`}>
                                            {claimOverview?.serialNumber ? claimOverview?.serialNumber : ''}
                                        </span>
                                    </div>
                                )}
                                {claimOverview?.replacementShiptoPhone && (
                                    <div className='no-gutters'>
                                        <b className={`col-2 ${country === 'DE' ? 'col-lg-6' : 'col-lg-3'}`}>
                                            {translations.phone || 'Phone'}:{' '}
                                        </b>
                                        <span className={`col-10 ${country === 'DE' ? 'col-lg-6' : 'col-lg-9'}`}>
                                            {claimOverview?.replacementShiptoPhone ? (
                                                <InternationalPhoneWithCode
                                                    number={claimOverview?.replacementShiptoPhone}
                                                />
                                            ) : (
                                                ''
                                            )}
                                        </span>
                                    </div>
                                )}
                            </Col>
                        </Row>
                    </Col>
                    <Col
                        md='5'
                        className={styles.claimInfo}
                    >
                        {ccNumber !== null && ccType !== null && (
                            <>
                                <h3 className={styles.claimDetailsH6}>
                                    {translations.deductible || englishVars.deductibleName}
                                </h3>
                                <ul className='noBullets'>
                                    <li>
                                        {translations.total || 'Total'}:&nbsp;
                                        <NumberFormat
                                            value={
                                                !claimOverview || !claimOverview?.deductibleTotal
                                                    ? 0
                                                    : parseInt(claimOverview?.deductibleTotal)
                                            }
                                            displayType={'text'}
                                            thousandSeparator={currency.thousandsDelimiter}
                                            decimalSeparator={currency.decimalDelimiter}
                                            prefix={
                                                currencyPrefixCountries.includes(country.toUpperCase())
                                                && currency.symbol
                                            }
                                            suffix={currencySuffix()}
                                            decimalScale={2}
                                            fixedDecimalScale={currency.allowDecimal}
                                        />
                                    </li>
                                    <li>
                                        {getCCType()}
                                        {translations.endingWith || 'ending with'} {ccNumber}
                                    </li>
                                </ul>
                            </>
                        )}
                    </Col>

                    <Col
                        md='7'
                        className={styles.claimInfo}
                    >
                        {!pendingIncidentStatus && claimOverview.originalIncidentDetails === null && (
                            <>
                                <h3 className={styles.claimDetailsH6}>
                                    {translations.incidentDetails || 'Incident Details'}
                                </h3>
                                <ul className='noBullets'>
                                    <li>
                                        {!!claimOverview?.coverageName
                                            && getIncidentType(claimOverview?.coverageName, translations)}
                                        {!!claimOverview?.incidentDate
                                            && moment(claimOverview?.incidentDate).format(date.momentJsFormat)}
                                    </li>
                                    {!!claimOverview?.incidentDetails && (
                                        <li className={styles.wrapText}>{claimOverview.incidentDetails}</li>
                                    )}
                                </ul>
                            </>
                        )}
                        {!pendingIncidentStatus && claimOverview.originalIncidentDetails !== null && (
                            <>
                                <h3 className={styles.claimDetailsH6}>
                                    {translations.incidentDetails || 'Incident Details'}
                                </h3>
                                <ul className='noBullets'>
                                    <li>
                                        {!!claimOverview?.coverageName
                                            && getIncidentType(claimOverview?.coverageName, translations)}
                                        {moment(claimOverview?.originalIncidentDetails?.substring(0, 11))?.format(
                                            date.momentJsFormat
                                        )}
                                    </li>
                                    <li className={styles.wrapText}>
                                        {claimOverview.originalIncidentDetails?.substring(10)}
                                    </li>
                                </ul>
                                <h3 className={classNames(styles.claimDetailsSubHeader, styles.detailClaimMargin)}>
                                    {translations.additionalDesc || 'Additional Description'}
                                </h3>
                                <ul className='noBullets'>
                                    <li>
                                        {!!claimOverview?.coverageName
                                            && getIncidentType(claimOverview?.coverageName, translations)}
                                        {!!claimOverview?.incidentDate
                                            && moment(claimOverview?.incidentDate).format(date.momentJsFormat)}
                                    </li>
                                    {!!claimOverview?.incidentDetails && (
                                        <li className={styles.wrapText}>{claimOverview.incidentDetails}</li>
                                    )}
                                </ul>
                            </>
                        )}
                    </Col>
                    <Col
                        md='5'
                        className={styles.claimInfo}
                    >
                        <DetailsDisplayBlock
                            title={translations.shippedTo || 'Replacement Shipped To'}
                            address={address}
                            clientId={clientId}
                            countryCode={countryCode}
                            phone={<InternationalPhoneWithCode number={claimOverview?.replacementShiptoPhone} /> || ''}
                            email={claimOverview?.replacementShiptoEmail}
                        />
                        {claimOverview?.modelNumber?.toLowerCase()?.includes('watch') && claimOverview?.accessories && (
                            <div
                                md='5'
                                className={classNames(styles.claimInfo, styles.detailClaimMargin)}
                            >
                                <h3 className={styles.claimDetailsSubHeader}>
                                    {translations.accessoriesIncluded || 'Accessories Included'}
                                </h3>
                                <ul className='noBullets'>
                                    <li>{translations.watchBand || 'Watch Band'}</li>
                                    <li>{claimOverview?.accessories}</li>
                                </ul>
                            </div>
                        )}
                    </Col>
                    {claimOverview?.uploadedPendingInfoDocuments?.length > 0 && (
                        <Col
                            md='7'
                            className={styles.claimInfo}
                        >
                            <h3 className={styles.claimDetailsH6}>
                                {translations.supportingDocuments || 'Supporting Documents'}
                            </h3>
                            <ul className='noBullets'>
                                {claimOverview?.uploadedPendingInfoDocuments?.map((doc) => getUploadedDocs(doc))}
                            </ul>
                        </Col>
                    )}
                </Row>
            )}
            {viewFileModal && (
                <ViewFileModal
                    isOpen={viewFileModal}
                    toggle={() => setViewFileModal(!viewFileModal)}
                    selectedDoc={selectedDoc}
                    modalClassName='viewDocModal'
                    contentClassName='viewDocModalContent'
                    centered={true}
                    size='lg'
                />
            )}
        </section>
    );
}
